import { makeStyles } from '@material-ui/core';

import { Theme } from 'src/theme';

export const useStyles = makeStyles((theme: Theme) => ({
  drawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)',
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerCollapsed: {
    width: 73,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  avatar: {
    // cursor: 'pointer', - Removed until user profile is implemented.
    width: 64,
    height: 64,
  },
  perfectScrollbar: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
